import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, } from 'react-redux';
import { CardBody, Button } from 'reactstrap';
import { translate } from "react-translate";
import TableKits from './TableKits';
import Paginator from '../Common/Paginator';
import Search from '../Common/Search'
import Loading from "plugins/TS-lib-utils-public/components/Loading/LoadingGlobal";
import { actionGetKitsList } from 'store/actions/kitsActions';
import { useHistory } from 'react-router-dom';

const KitsList = (props) => {
    const dispatch = useDispatch();
    const { data } = useSelector(state => state.kitsReducer.kits);
    const { page, lastPage, limit } = useSelector(state => state.kitsReducer.kits);
    const [loading, setloading] = useState(false);
    const [loadingLocal, setloadingLocal] = useState(false);
    const [_page, setPage] = useState(0);
    const [_limit, setLimit] = useState(10);
    const [totalPage, setTotalPage] = useState(0);
    const [filter, setFilter] = useState(null);
    const history = useHistory();
    const { is_creating_kits } = useSelector(state => state.managementUserReducer);

    useEffect(() => {
        dispatch(actionGetKitsList(_page, _limit));
    }, []);

    useEffect(() => {

        if (data) {
            setloading(false);
            setloadingLocal(false);
            setPage(page);
            setLimit(limit);
            setTotalPage(lastPage);
        }

    }, [dispatch, data]);

    //method called by paginator and search
    function changeDataSearch(page, filter = null) {
        //if the search type "" refresh all data
        setloadingLocal(true)
        if (filter == null) {
            setFilter(null);
            dispatch(actionGetKitsList(page, _limit));
        } else {
            //we save search input text, therefore we will only paginate the search results
            setFilter(filter);
            dispatch(actionGetKitsList(page, _limit, filter));
        }
    }

    const createKit = (e) => {
        e.preventDefault();
        history.push(`/admin/kits/form/`);
    }

    return (
        <div className='content user-manual'>
                <CardBody>
                    <div>
                        <Loading loading={loading} />
                        <Search placeholder={"search-text-logList"} callback={changeDataSearch} />

                        {!is_creating_kits && (
                            <Button
                                size="sm"
                                color="info"
                                onClick={(e) => { createKit(e) }}
                                >
                                Add new kit
                            </Button>
                        )}
                        

                        <TableKits data={data} loading={loadingLocal} page={page} callback={changeDataSearch} />
                        <Paginator totalPages={totalPage} currentPage={_page} pageSize={_limit} filter={filter} callback={changeDataSearch} />
                    </div>
                </CardBody>
        </div>
    );
};
export default translate("kits")(KitsList);